import { useNavigate } from "react-router";
import { bemCN } from "../../config/bem-classname";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import "./policy-page.scss";
import { links } from "../../config/links";
import {
  localStorageService,
  LocalStorageVariableName,
} from "../../services/localStorage-service";
import { Menu } from "../../components/menu/menu";

const policyPageCn = bemCN("policy-page");

export const PolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className={policyPageCn()}>
      <Menu title="Политика кофиденциальности" />
      <div className={policyPageCn("text")}>
        <p className={policyPageCn("title-1")}>1. Общие положения</p>
        <p className={policyPageCn("simple-text")}>
          1.1. Настоящее Соглашение о конфиденциальности (далее — «Соглашение»)
          регулирует порядок сбора, использования, обработки и защиты
          информации, предоставляемой пользователями (далее — «Пользователь»)
          при использовании приложения YUMI (далее — «Приложение»).
        </p>
        <p className={policyPageCn("simple-text")}>
          1.2. Использование Приложения означает согласие Пользователя с
          условиями настоящего Соглашения.
        </p>
        <p className={policyPageCn("title-1")}>
          2. СБОР И ИСПОЛЬЗОВАНИЕ ИНФОРМАЦИИ
        </p>
        <p className={policyPageCn("simple-text")}>
          2.1. В рамках использования Приложения могут собираться следующие
          данные:
        </p>
        <ul>
          <li>
            Персональные данные (ФИО, контактные данные, адрес электронной почты
            и др.);
          </li>
          <li>
            Техническая информация (IP-адрес, данные о браузере, устройстве и т.
            д.);
          </li>
          <li>
            Техническая информация (IP-адрес, данные о браузере, устройстве и т.
            д.);
          </li>
        </ul>
        <p className={policyPageCn("simple-text")}>
          2.2. Собранная информация используется исключительно для:
        </p>
        <ul>
          <li>Предоставления и улучшения работы Приложения;</li>
          <li>Обратной связи с Пользователем;</li>
          <li>Обеспечения безопасности и защиты от мошенничества.</li>
        </ul>
        <p className={policyPageCn("title-1")}>3. РАЗГЛАШЕНИЕ ИНФОРМАЦИИ</p>
        <p className={policyPageCn("simple-text")}>
          3.1. Приложение обязуется не передавать персональные данные третьим
          лицам без согласия Пользователя, за исключением случаев,
          предусмотренных законодательством.
        </p>
        <p className={policyPageCn("simple-text")}>
          3.2. Разглашение информации может быть осуществлено в следующих
          случаях:
        </p>
        <ul>
          <li>
            По запросу государственных органов в рамках действующего
            законодательства;
          </li>
          <li>
            Для защиты прав и интересов Приложения при нарушении Пользователем
            условий Соглашения.
          </li>
        </ul>
        <p className={policyPageCn("title-1")}>4. ЗАЩИТА ДАННЫХ</p>
        <p className={policyPageCn("simple-text")}>
          4.1. Приложение принимает все разумные меры для защиты персональной
          информации Пользователя от несанкционированного доступа, изменения,
          раскрытия или уничтожения.
        </p>
        <p className={policyPageCn("simple-text")}>
          4.2. Доступ к персональным данным предоставляется только
          уполномоченным лицам, обязующимся соблюдать конфиденциальность.
        </p>
        <p className={policyPageCn("title-1")}>5. ПРАВА ПОЛЬЗОВАТЕЛЯ</p>
        <p className={policyPageCn("simple-text")}>
          5.1. Пользователь имеет право:
        </p>
        <ul>
          <li>
            Запрашивать информацию о своих персональных данных, хранящихся в
            Приложения;
          </li>
          <li>Требовать изменения или удаления своих данных;</li>
          <li>Отозвать согласие на обработку персональных данных.</li>
        </ul>
        <p className={policyPageCn("title-1")}>6. ИЗМЕНЕНИЕ УСЛОВИЙ</p>
        <p className={policyPageCn("simple-text")}>
          6.1. Приложение оставляет за собой право изменять условия настоящего
          Соглашения.
        </p>
        <p className={policyPageCn("simple-text")}>
          6.2. Обновлённая версия Соглашения публикуется в приложении, и
          продолжение использования Приложения означает согласие с изменениями.
        </p>
        <p className={policyPageCn("title-1")}>7. КОНТАКТНАЯ ИНФОРМАЦИЯ</p>
        <p className={policyPageCn("simple-text")}>
          По всем вопросам, связанным с обработкой персональных данных,
          Пользователь может обратиться по адресу: yumimyths@gmail.com
        </p>
        <p className={policyPageCn("simple-text")}>
          Настоящее Соглашение вступает в силу с момента его принятия
          Пользователем и действует до момента прекращения использования
          Приложения.
        </p>
      </div>
    </div>
  );
};
